const normalizeAmount = (n) => {
  let fixedAmount = Math.trunc(n / 100);

  if(fixedAmount % 10 != 9) {
    fixedAmount = ((Math.round(fixedAmount / 10) * 10) - 1);
  }

  // console.log(n / 100, "=>", fixedAmount);

  return fixedAmount * 100;
}

const pfFormattedMoney = (amount) => {
  return theme.Currency.formatMoney(normalizeAmount(amount), theme.settings.moneyFormat).replace(/<[^>]*>/g, '').trim();
}

// Debounce utility
var variantChangeTimer = null;
function debouncedHandleVariantChange(items) {
  clearTimeout(variantChangeTimer);
  variantChangeTimer = setTimeout(function() {
    handleVariantChange(items);
  }, 300);
}

const getVariantPriceData = (variant, item) => {
  const data = {
    id: item.id,
    quantity: item.quantity,
    price: variant.price,
    priceFormatted: theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat),
    comparePrice: variant.compare_at_price || variant.price, // fallback to price if no compare
    comparePriceFormatted: theme.Currency.formatMoney(variant.compare_at_price || variant.price, theme.settings.moneyFormat),
    title: variant.title,
    available: variant.available
  };

  return data;
}

function getAllVariantPrices(variantsArray) {
  var requests = variantsArray.map(function(item) {
    const fetchUrl = '/variants/' + item.id + '.js';

    if (window.pfVariantPrices && window.pfVariantPrices[fetchUrl]) {
      return Promise.resolve(
        getVariantPriceData(window.pfVariantPrices[fetchUrl], item)
      );
    }

    return fetch(fetchUrl)
      .then(function(response) {
        return response.json();
      })
      .then(function(variant) {
        if (!window.pfVariantPrices) {
          window.pfVariantPrices = {};
        }

        window.pfVariantPrices[fetchUrl] = variant;

        return getVariantPriceData(variant, item);
      });
  });

  return Promise.all(requests);
}


function handleVariantChange(variants) {
  if (!variants || !variants.length) return;

  getAllVariantPrices(variants).then(function(results) {
    var total = 0;
    var compareTotal = 0;
    var length = results.length / 2;
    var lowestPrice = results[0].price;
    const variantElements = document.querySelectorAll(".pf-bundle-item[data-active='true'] .pf-bundle-pack");

    results.forEach(function(variant, index) {
      var linePrice        = variant.price * variant.quantity;
      var compareLinePrice = variant.comparePrice * variant.quantity;
      total        += linePrice;
      compareTotal += compareLinePrice;
      console.log('Variant:', variant.title, '| Price:', variant.priceFormatted, '| Compare:', variant.comparePriceFormatted);

      variantElements[index].setAttribute("data-price", variant.price)

      if(variant.price < lowestPrice){
        lowestPrice = variant.price;
      }
    });

    if(results.length >= 4){
      console.log("jazbah", length)
      total = total - lowestPrice;
    }
    // compareTotal = compareTotal / length;

    variantElements.forEach(variant => {
      variant.classList.remove("lowest_price");
    });

    Array.from(document.querySelectorAll(`.pf-bundle-item[data-active='true'] .pf-bundle-pack[data-price="${lowestPrice}"]`)).reverse()[0]
    .classList.add("lowest_price");

    console.log("lowestPrice",lowestPrice)

    // Strip HTML span tags — get plain price text only
    var activeBundle = document.querySelector(".pf-bundle-item[data-active='true']");
    if (!activeBundle) return;

    var discountPriceEl  = activeBundle.querySelector('.pf-bundle-prices .pf-price-discount .money');
    var originalPriceEl  = activeBundle.querySelector('.pf-bundle-prices .pf-price-original .money');

    const pfBundleItem = discountPriceEl?.closest(".pf-bundle-item");
    const discountAmount = Number(pfBundleItem?.dataset.discountAmount || 0) / 100;

    const discountValue = (total * discountAmount) || 0;

    var totalFormatted = pfFormattedMoney(total - discountValue);
    var compareTotalFormatted = pfFormattedMoney(compareTotal);

    console.log('Total:', totalFormatted);
    console.log('Compare Total:', compareTotalFormatted);

    if (discountPriceEl)  discountPriceEl.textContent  = totalFormatted;
    if (originalPriceEl)  originalPriceEl.textContent  = compareTotalFormatted;
  });
}

class PfBundleSelector extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    this.cachedVariants = {};

    const { signal } = this.#controller;
    this.variantImages = {};
    this.variants = JSON.parse(this.dataset.productVariants);

    this.dataset.variantImages?.split(",")?.forEach(vimg => {
      const [id, imgUrl] = vimg.trim().split(":");
      this.variantImages[id] = imgUrl;
    });

    this.bundleItems.forEach(bundleItem => {
      bundleItem.addEventListener("click", this.onBundleClick.bind(this), { signal });
    });

    this.bundleSelectEls.forEach(selectElm => {
      selectElm.addEventListener("change", this.onSelectChange.bind(this), { signal });
    });

    this.syncPrices();
    this.syncVariant();

    // PERF: removed the unconditional this.prefetchVariants() call that used to run here.
    // It looped over every variant on the product and eagerly fetched the ENTIRE product
    // page HTML for each one (/products/<handle>?variant=<id>&section_id=<id>) with no
    // throttling or visibility check — on a 21-30 variant product that meant 20-36 fetches
    // of ~800KB uncompressed HTML each, all firing in one burst on page load, well before
    // any shopper touched a bundle option. onSelectChange() below already fetches + caches
    // a variant's HTML lazily (via getVariantHtml) the first time it's actually needed, so
    // removing the eager prefetch costs nothing but a single small fetch on first use of a
    // given pack combo, instead of ~30 unconditional fetches nobody asked for.
    this.prefetchVariantsPrices();
    this.initializeBundleScript();

    document.addEventListener('change', function(e) {
      if (
        e.target.closest('.pf-bundle-item') &&
        e.target.classList.contains('pf-bundle-select')
      ) {
        // PERF/FIX: not just ".Size" - bundles on Color-only (or any other
        // single-option) products need their price recalculated too.
        var items = [...document.querySelectorAll(".pf-bundle-item[data-active='true'] .pf-bundle-variant select")]
          .map(function(sl) {
            return { id: sl.value, quantity: 1 };
          });

        console.log('items:', items);
        debouncedHandleVariantChange(items);
      }
    }, { signal });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  get activeBundleItem() {
    return this.querySelector(".pf-bundle-item[data-active='true']");
  }

  get bundleItems() {
    return Array.from(this.querySelectorAll(".pf-bundle-item"));
  }

  get bundleSelectEls() {
    return Array.from(this.querySelectorAll(".pf-bundle-select"));
  }

  get comparePriceEls() {
    return Array.from(document.querySelectorAll(".product__price.product__price--compare .money"));
  }

  get salePriceEls() {
    return Array.from(document.querySelectorAll(".product__price.on-sale .money"));
  }

  prefetchVariants() {
    // PERF: was JSON.parse(this.dataset.productJson) — the full escaped
    // product object (all variants/images/metafields), only ever used here
    // for .handle and .variants. .variants is already parsed above from the
    // separate, much smaller data-product-variants attribute; .handle now
    // comes from its own tiny data-product-handle attribute instead.
    const sectionId = this.dataset.sectionId;
    const productHandle = this.dataset.productHandle;

    if(!sectionId || !productHandle) return;

    this.variants?.forEach(async variant => {
      const variantId = variant.id;
      const fetchUrl = `/products/${productHandle}?variant=${variantId}&section_id=${sectionId}`;

      if(!this.cachedVariants[fetchUrl]) {
        const res = await fetch(fetchUrl);
        const html = await res.text();

        this.cachedVariants[fetchUrl] = html;
      }
    });
  }

  prefetchVariantsPrices() {
    if (!window.pfVariantPrices) window.pfVariantPrices = {};

    this.variants?.forEach(async variant => {
      const fetchUrl = '/variants/' + variant.id + '.js';

      if(!window.pfVariantPrices[fetchUrl]) {
        window.pfVariantPrices[fetchUrl] = variant;
      }
    })
  }

  syncPrices() {
    const comparePrice = this.activeBundleItem.querySelector(".pf-price-original");
    const salePrice = this.activeBundleItem.querySelector(".pf-price-discount");

    this.comparePriceEls?.forEach(el => {
      el.textContent = comparePrice.textContent;
    });

    this.salePriceEls?.forEach(el => {
      el.textContent = salePrice.textContent;
    });

    const priceElms = document.querySelectorAll(".pf-bundle-prices > p");

    priceElms.forEach(priceEl => {
      const moneyEl = priceEl.querySelector(".money");
      if(!moneyEl) return;

      const formatted = pfFormattedMoney(Number(priceEl.dataset.value));

      if(formatted != "Rs. 0") {
        moneyEl.textContent = formatted;
      }
    });
  }

  onBundleClick(e) {
    const el = e.currentTarget;
    if(!el || el.dataset.active == "true") return;

    if(this.activeBundleItem) this.activeBundleItem?.setAttribute("data-active", false);

    e.currentTarget?.setAttribute("data-active", true);
    this.syncPrices();

    // PERF: lazily build swatches / run variant checks the first time this
    // tier is opened, instead of doing it for every tier on page load.
    if (!this.initializedBundleTiers) this.initializedBundleTiers = new Set();

    if (!this.initializedBundleTiers.has(el)) {
      el.querySelectorAll('.pf-bundle-select').forEach(function (select) {
        try {
          buildColorSwatches(select.id);
        } catch (err) {
          console.error('buildColorSwatches failed for', select.id, err);
        }
      });

      el.querySelectorAll('.pf-bundle-pack').forEach(function (pack) {
        try {
          handlePackVariantChange(pack);
        } catch (err) {
          console.error('handlePackVariantChange failed', err);
        }
      });

      this.initializedBundleTiers.add(el);
    }
  }

  async getVariantHtml(fetchUrl) {
    if(this.cachedVariants[fetchUrl]) {
      return this.cachedVariants[fetchUrl];
    }

    const res = await fetch(fetchUrl);
    const html = await res.text();

    this.cachedVariants[fetchUrl] = html;
    return html;
  }

  async onSelectChange(e) {
    const variantId = e.target.value;
    if (!variantId) return;

    const currentPackEl = e.target.closest(".pf-bundle-pack");
    if (!currentPackEl) return;

    const sectionId = this.dataset.sectionId;
    // PERF: was JSON.parse(this.dataset.productJson).handle — see prefetchVariants() above.
    const productHandle = this.dataset.productHandle;

    try {
      currentPackEl.classList.add("pf-disabled");
      const fetchUrl = `/products/${productHandle}?variant=${variantId}&section_id=${sectionId}`;

      const html = await this.getVariantHtml(fetchUrl);

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const newPackEl = doc.querySelector(
        `.pf-bundle-pack[data-pack-id="${currentPackEl.dataset.packId}"]`
      );

      const packImgEl = newPackEl.querySelector(".pf-pack-img");

      const newImageEl = document.createElement("img");
      newImageEl.src = this.variantImages[variantId];
      packImgEl.replaceChildren(newImageEl);

      if (newPackEl) {
        currentPackEl.replaceWith(newPackEl);
      }

      newPackEl.querySelectorAll(".pf-bundle-select").forEach(select => {
        select.addEventListener("change", this.onSelectChange.bind(this), {
          signal: this.#controller.signal
        });
          buildColorSwatches(select.id);
      });


    } catch (err) {
      console.error("Variant update failed", err);
    }
  }

  initializeBundleScript() {
    // PERF: only build swatches / run variant checks for the tier that is
    // actually visible on load (the other tiers are collapsed and hidden).
    // Hidden tiers are lazily initialized the first time the shopper opens
    // them - see onBundleClick() below. This avoids doing 3x-7x the DOM
    // work on every page load for tiers most visitors never expand.
    var activeItem = this.activeBundleItem;

    if (activeItem) {
      activeItem.querySelectorAll('.pf-bundle-select').forEach(function (select) {
        buildColorSwatches(select.id);
      });

      activeItem.querySelectorAll('.pf-bundle-pack').forEach(function (pack) {
        handlePackVariantChange(pack);
      });
    }

    this.initializedBundleTiers = new Set(activeItem ? [activeItem] : []);


    // Run once on load with initial select values.
    // PERF/FIX: not just ".Size" - bundles on Color-only (or any other
    // single-option) products need their price recalculated too.
    var initialItems = [...document.querySelectorAll(".pf-bundle-item[data-active='true'] .pf-bundle-variant select")]
      .map(function(sl) {
        return { id: sl.value, quantity: 1 };
      });

    if (initialItems.length) handleVariantChange(initialItems);
  }

  syncVariant() {
    const {selectedVariant: variantData, productVariants: variantsData} = this.dataset;
    if (!variantData) return;
    let selectedVariant = JSON.parse(variantData);
    let selectedColor, colorIndex;
    const sizeSelects = this.querySelectorAll('.pf-bundle-variant[index="0"] .pf-bundle-select');
    const colorSelects = this.querySelectorAll('.pf-bundle-variant[index="1"] .pf-bundle-select');

    // default color selection
    const colors = document.querySelectorAll(".variant-input-wrap[data-handle='color'] .variant-input");
    colors.forEach((color) => {
      const { index, value } = color.dataset;
      const label = color.querySelector(".variant__button-label");
      if(!label) return;

      if (index && value && selectedVariant) {
        if (selectedVariant[index] === value) {
          label.click();
          selectedColor = value;
          colorIndex = index;
        }
      }


      label.addEventListener("click", () => {
        colorSelection(index, value);
      });
    });

// Auto-switch if URL variant is out of stock
const allVariants = JSON.parse(variantsData || '[]');
const urlVariantId = new URLSearchParams(window.location.search).get('variant');
const urlVariantObj = allVariants.find(v => String(v.id) === String(urlVariantId));

if (urlVariantObj && !urlVariantObj.available) {
  const fallbackVariant = allVariants.find(v => v.available);

  if (fallbackVariant) {
    // Click the next available color swatch
    const allColorSwatches = document.querySelectorAll(".variant-input-wrap[data-handle='color'] .variant-input");
    allColorSwatches.forEach((color) => {
      const { index, value } = color.dataset;
      const label = color.querySelector(".variant__button-label");
      if (label && fallbackVariant[index] === value) {
        label.click(); // this triggers full color switch including bundle
      }
    });
  }
  return;
}

    // available variant selection
    if(!selectedColor && !colorIndex) return;
    const availableVariant = variants.find(
      (variant) =>
        variant.available &&
        variant[colorIndex] === selectedColor
    );

    sizeSelects.forEach((sizeSelect)=>{
      sizeSelect.value = availableVariant.id;
      sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
    })

    function colorSelection(index, value){
      const availableVariant = variants.find(
        (variant) =>
          variant.available &&
          variant[index] === value
      );

      const doubleOption = Number(
        document.querySelector(".pf-bundle-group .pf-bundle-pack")?.dataset.optionCount
      ) > 1;

      const query = doubleOption ? '.pf-bundle-variant[index="1"] .pf-bundle-select' : '.pf-bundle-variant[index="0"] .pf-bundle-select';

      const colorSelects = document.querySelectorAll(query);

      colorSelects.forEach((colorSelect)=>{
        const colorOption = Array.from(colorSelect.options).find(
          (option) => option.label === value
        );

        if (colorOption) {
          colorSelect.value = colorOption.value;
          colorSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      })

      if(!doubleOption) return;

      setTimeout(()=>{
        const sizeSelects = document.querySelectorAll('.pf-bundle-variant[index="0"] .pf-bundle-select');

        sizeSelects.forEach((sizeSelect) => {
          const firstAvailableOption = [...sizeSelect.options].find(
            (option) => !option.disabled
          );

          if (!firstAvailableOption) return;

          sizeSelect.value = firstAvailableOption.value;
          sizeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }, 500);
    }
  }
}

if(!customElements.get("pf-bundle-selector")) {
  customElements.define("pf-bundle-selector", PfBundleSelector);
}

// Stamp the first available variant into the URL if no variant is present.
// FIX: this used to be a hard `window.location.replace()`, which reloads
// the whole page a split second after first paint - on the PDP that meant
// the correctly-priced bundle briefly appeared, then a second full page
// load re-rendered it (and, worse, any reload can pick up a stale/cached
// response, appearing to "revert" to the old price). Updating the URL via
// history.replaceState keeps the address bar in sync without a reload.
(function() {
  const urlVariantId = new URLSearchParams(window.location.search).get('variant');
  if (!urlVariantId) {
    const bundleEl = document.querySelector('pf-bundle-selector');
    if (!bundleEl) return;

    const allVariants = JSON.parse(bundleEl.dataset.productVariants || '[]');
    const firstAvailable = allVariants.find(v => v.available);

    if (firstAvailable) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', firstAvailable.id);
      window.history.replaceState(null, '', url.toString());
    }
  }
})();
